export default "__VITE_ASSET__AdBz1hHp__"